/** 创建界面、API 与 Bot 共用的角色显示名约束，不把标点误当作内部 ID。 */
export const CHARACTER_NAME_MAX_LENGTH = 64;

export function isCharacterDisplayName(value: unknown): value is string {
  return typeof value === "string"
    && value.trim() === value
    && [...value].length > 0
    && [...value].length <= CHARACTER_NAME_MAX_LENGTH
    && !/[\p{Cc}\p{Cf}<>@`\\]/u.test(value);
}
